import { computed, inject, Injectable, signal } from '@angular/core';
import { DateService } from '@softline/core';
import { DateRange } from '@softline/ui-core';

@Injectable()
export class PurchaseStatisticsQueryService {

  private dateService = inject(DateService);

  source = signal<'purchase' | 'goodsReceipt'>('purchase');
  sourceTable = computed(() => {
    return this.source() === 'purchase' ? 'erw' : 'ek';
  })

  dateRange = signal<DateRange>({from: '2022-01-01', to: '2022-12-31'})
  referencePeriod = signal<DateRange>({from: '2021-01-01', to: '2021-12-31'})

  branch = signal<string | null>(null);
  productGroup = signal<object | null>(null);
  mainGroup = signal<object | null>(null);
  subGroup = signal<object | null>(null);
  supplier = signal<object | null>(null);
  supplySupplier = signal<object | null>(null);
  distributionChannel = signal<object | null>(null);
  warehouse = signal<object | null>(null);
}
